<ng-template #calendar>
  <p-datePicker [id]="inputElementId"
                [ngModel]="timedDate" (ngModelChange)="onChange($event)"
                [showTime]="showTime"
                dateFormat="dd/mm/yy"
                hourFormat="24"
                timeSeparator=":"
                appendTo="body"
                [showClear]="showClear"
                [placeholder]="placeholder"
  />
</ng-template>

@if (!useFloatLabel) {
  <label [for]="inputElementId" *ngIf="hasLabel" [style.width]="labelWidth">{{ label }}</label>
  <ng-container *ngTemplateOutlet="calendar"/>
} @else {
  <p-floatlabel [variant]="useFloatLabel">
    <ng-container *ngTemplateOutlet="calendar"/>
    <label>{{ label }}</label>
  </p-floatlabel>
}
